import { Button, Dropdown, Flex, Modal, Table, Tag, Typography } from "antd";
import React, { useEffect, useState } from "react";
import CustomHeader from "../../components/header/CustomHeader";
import api from "../../api";
import { useToast } from "../../components/toast/toast";
import { IconEdit, IconPlus, IconTrash } from "@tabler/icons-react";
import CustomModal from "../../components/modal/CustomModal";
import CustomInput from "../../components/input/CustomInput";
import CustomSelect from "../../components/select/CustomSelect";
import { validateEmail } from "../../utilities/utils";
import ConfirmModal from "../../components/modal/ConfirmModal";

const Staff = () => {
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [selected, setSelected] = useState(null);
  const [name, setName] = useState("");
  const [mail, setMail] = useState("");
  const [role, setRole] = useState("");
  const [createdUser, setCreatedUser] = useState(null); // { email, password }
  const [roleOptions, setRoleOptions] = useState([]);

  const toast = useToast();

  const fetchList = async () => {
    setIsLoading(true);
    const res = await api.get_user_list();
    // console.log("user res --->", res);

    if (res.status === 200) {
      setList(res.data.data);
    } else {
      toast(res.data?.message || "Алдаа гарлаа", "error");
    }
    setIsLoading(false);
  };

  useEffect(() => {
    fetchList();
    api.get_roles().then((res) => {
      if (res?.status === 200) {
        setRoleOptions(
          res.data.data.map((r) => ({ label: r.name, value: r.name })),
        );
      }
    });
  }, []);

  const submitHandler = async () => {
    const res = await api.create_user({ name, role, gmail: mail });
    if (res?.status === 201) {
      const data = res.data?.data;
      setCreatedUser({
        email: data?.UserPrimaries?.[0]?.primary || mail,
        password: data?.tempPassword,
      });
      clearHandler();
      fetchList();
    } else {
      toast(res?.data?.message || "Алдаа гарлаа", "error");
    }
  };

  const deleteHandler = async () => {
    const res = await api.delete_user(selected);
    if (res?.status === 200) {
      toast("Амжилттай устгалаа", "success");
      setIsDeleteModal(false);
      setSelected(null);
      fetchList();
    } else {
      toast(res?.data?.message || "Алдаа гарлаа", "error");
    }
  };

  const columns = [
    {
      title: "Ажилтан",
      key: "staff",
      render: (_, record) => {
        const name = record.UserProfile?.name || "-";
        const email =
          record.UserPrimaries.find((p) => p.type === "email")?.primary || "-";

        return (
          <div>
            <h4 style={{ fontWeight: 600 }}>{name}</h4>
            <p style={{ fontSize: 12, color: "#888" }}>{email}</p>
          </div>
        );
      },
    },
    {
      title: "Төлөв",
      key: "role",
      render: (_, record) => {
        const data = record.UserPrimaries.find((p) => p.type === "email");
        if (data?.is_verified) return <Tag color="green">Баталгаажсан</Tag>;
        if (data?.is_verified === false)
          return <Tag color="red">Баталгаажаагүй</Tag>;
        return "-";
      },
    },
    {
      title: "Эрх",
      key: "role",
      render: (_, record) => record.Role?.name || "-",
    },
    {
      title: "Үйлдэл",
      key: "action",
      width: 150,
      render: (_, record) => {
        const items = [
          {
            key: "edit",
            label: "Засах",
            icon: <IconEdit size={14} />,
          },
          {
            key: "delete",
            label: "Устгах",
            icon: <IconTrash size={14} />,
          },
        ];

        return (
          <Dropdown
            menu={{
              items,
              onClick: ({ key }) => {
                if (key === "edit") {
                  console.log("edit");
                } else if (key === "delete") {
                  setSelected(record.id);
                  setIsDeleteModal(true);
                }
              },
            }}
            trigger={["hover"]}
          >
            <Button type="text" icon={<IconEdit size={18} />} />
          </Dropdown>
        );
      },
    },
  ];

  const clearHandler = () => {
    setName("");
    setMail("");
    setRole("");
    setShowModal(false);
  };

  return (
    <Flex vertical>
      <CustomHeader
        title={"Ажилчидын жагсаалт"}
        rightSide={
          <Button
            type="primary"
            style={{ padding: "0 30px" }}
            onClick={() => setShowModal(true)}
          >
            <IconPlus size={16} /> Ажилтан нэмэх
          </Button>
        }
      />

      <Table
        columns={columns}
        rowKey="id"
        dataSource={list}
        loading={isLoading}
      />

      <CustomModal
        title={"Ажилтан нэмэх"}
        open={showModal}
        onCancel={clearHandler}
        disabled={!(validateEmail(mail) && name && role)}
        onOk={submitHandler}
      >
        <Flex vertical gap={"10px"}>
          <CustomInput
            title={"Нэр"}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <CustomInput
            title={"Имэйл"}
            value={mail}
            onChange={(e) => setMail(e.target.value)}
          />
          <CustomSelect
            title={"Эрх"}
            value={role}
            onChange={(e) => setRole(e)}
            options={roleOptions}
            // options={[
            //   { label: "Админ", value: "admin" },
            //   { label: "Эдитор", value: "editor" },
            //   { label: "Оператор", value: "operator" },
            //   // { label: "Дуудлагын ажилтан", value: "call_agent" },
            // ]}
          />
          <Flex
            style={{
              padding: "10px",
              border: "1px solid #FA8C16",
              borderRadius: "4px",
              backgroundColor: "#ffefde",
            }}
          >
            {/* <p style={{ textAlign: "justify" }}>
              Хэрэглэгчийн нууц үг "
              <span style={{ color: "#0066cc", fontWeight: 600 }}>pass123</span>
              " гэж үүсгэгдэнэ. Хэрэглэгч бүртгүүлсний дараа өөрийн нууц үгийг
              аюулгүй байдлын үүднээс заавал солих шаардлагатай.
            </p> */}
            <p style={{ textAlign: "justify" }}>
              Хэрэглэгч үүсгэсний дараа түр нууц үг нэг удаа харагдана. Түүнийг
              хуулж ажилтанд өгнө үү. Ажилтан нэвтэрсний дараа нууц үгээ заавал
              солих шаардлагатай.
            </p>
          </Flex>
        </Flex>
      </CustomModal>

      <ConfirmModal
        variant="warning"
        showModal={isDeleteModal}
        setShowModal={setIsDeleteModal}
        cancelHandler={() => {
          setSelected(null);
        }}
        submitHandler={deleteHandler}
        title="Итгэлтэй байна уу?"
        description={
          <>
            '
            <span style={{ fontWeight: 600, color: "#0066cc" }}>
              Хэрэглэгч устгах
            </span>
            ' үйлдэл нь буцаах боломжгүйг анхаарна уу!
          </>
        }
      />

      <Modal
        title="Ажилтан амжилттай үүслээ"
        open={!!createdUser}
        onCancel={() => setCreatedUser(null)}
        footer={
          <Button type="primary" onClick={() => setCreatedUser(null)}>
            Хуулж авсан
          </Button>
        }
        maskClosable={false}
      >
        <Flex vertical gap={8}>
          <div>
            <span style={{ color: "#888" }}>Имэйл: </span>
            <Typography.Text copyable strong>
              {createdUser?.email}
            </Typography.Text>
          </div>
          <div>
            <span style={{ color: "#888" }}>Түр нууц үг: </span>
            <Typography.Text copyable strong style={{ color: "#0066cc" }}>
              {createdUser?.password}
            </Typography.Text>
          </div>
          <p style={{ color: "#FA8C16", fontSize: 12 }}>
            Энэ нууц үг зөвхөн одоо харагдана. Цонхыг хаасны дараа дахин харах
            боломжгүй.
          </p>
        </Flex>
      </Modal>
    </Flex>
  );
};

export default Staff;
